<template>
    <!-- <div class="container"> -->
        <!-- <span>Point de vente</span> -->
        <form action="" @submit.prevent="getArticles()">
            <v-sheet style="margin-top: 2em;margin-left:2em" width="200">
                <v-form  @submit.prevent>
                    <v-text-field 
                        clearable 
                        type="date" 
                        v-model="store.state.date"
                        label="Date" 
                        density="compact"
                        variant="outlined"
                        @change.prevent="setDate($event.target.value)" 
                    >
                    </v-text-field>
                    <v-combobox 
                    label="Point de vente"
                    :items="itemsEtabs"
                    v-model="store.state.etablissement"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <barcodeScanner></barcodeScanner>
                <h6>{{ scanBarCode }}</h6>
                <v-text-field
                    clearable
                    uppercase
                    v-model="filtreParams.reference"
                    label="Article"
                    variant="outlined"
                    density="compact"
                    @change.prevent=" store.commit('addBarcode',$event.target.value)" 
                ></v-text-field>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="marques"
                    :items="store.state.marques"
                    v-model="filtreParams.code_marque"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="Thèmes"
                    :items="itemsThemes"
                    v-model="filtreParams.code_theme"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="Rayons"
                    :items="itemsRayons"
                    v-model="filtreParams.code_rayon"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="Familles"
                    :items="itemsFamilles"
                    v-model="filtreParams.code_famille"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="SousFamilles"
                    :items="itemsSousFamilles"
                    v-model="filtreParams.sousfamilles"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="Collections"
                    :items="itemsCollections"
                    v-model="filtreParams.collection"
                    variant="outlined"
                    density="compact"
                ></v-combobox>
                <v-combobox
                    clearable
                    chips
                    multiple
                    label="promo"
                    :items="['PBG','OUTLET','BF','SOLD1','SOLD2','SOLD3','SOLVP','BAG','PGEUSS','BRADER']"
                    v-model="filtreParams.type_promo"
                    variant="outlined"
                    density="compact"
                    @update:model-value="setPromo"
                ></v-combobox>
                <v-checkbox label="Stock?" style="margin-top: -10px;" v-model="filtreParams.enStock" density="compact"></v-checkbox>
                <v-checkbox label="MonStock?" style="margin-top: -30px;" v-model="filtreParams.monStock" density="compact"></v-checkbox>
                <v-checkbox label="Promo?" style="margin-top: -30px;" v-model="filtreParams.promo" density="compact" @update:model-value="!filtreParams.promo?filtreParams.type_promo=null:null"></v-checkbox>
                <v-btn class="mt-2"  @click="getArticles()" block type="submit">Submit</v-btn>
                <v-overlay v-model="store.state.waiting"></v-overlay>
                </v-form>
            </v-sheet>
        </form>

</template>
<script setup>
    import { onMounted,computed,ref, watch } from 'vue';
    import axios from 'axios'
    import store from './store'
    import barcodeScanner from './barcodeScanner.vue';
    import router from './router'
    let itemsCollections=ref(['E23','E24','E25','E26','E27','H23','H24','H25','H26','H27','R23','R24','R25','R26','R27'])
    const itemsEtabs = ref(['DK03','MN01','EN11','FT04','LI02','RO06','AR09','CO18','HB21','BR08','NP10','GE22','OO10','CA24','VX05','PR25','LO07','WEDI','WENL','WEBE','WOOM','WETR','WCAM','DEPO','DWEB','NEGO','NGEXT','SHOPR','PHOTO','RECEP','DEFEC'])
    const article=ref('')
    let filtreParams=ref({
        etablissement: [] ,
        code_acheteur: null ,
        code_pole: null ,
        code_marque: null ,
        code_theme:null ,
        code_rayon: null ,
        code_famille: null ,
        code_sousfamille: null ,
        reference:null ,
        collection: null ,
        type_promo:null ,
        promo: null ,
        enStock : true,
        monStock : null
    })
    let itemsThemes = computed(() => {
        //console.log(filtreParams.value.code_marque);
        
    if (!filtreParams.value.code_marque || filtreParams.value.code_marque.length === 0) {
        return [...new Set(store.state.themes.map(theme => theme.split('|')[0].trim()))]
    }

    const codesMarquesSelectionnes = filtreParams.value.code_marque.map(item => {
        if (typeof item === 'string') {
        return item.split('-')[0].trim()
        } else {
        return item.code ? item.code.split('-')[0].trim() : ''
        }
    }).filter(code => code !== '')

    return [...new Set(store.state.themes
        .filter(theme => {
        const themeParts = theme.split('|')
        if (themeParts.length < 2) return false
        
        const codeMarqueTheme = themeParts[1].trim()
        return codesMarquesSelectionnes.includes(codeMarqueTheme)
        })
        .map(theme => theme.split('|')[0].trim()))]
    })
    let itemsRayons = computed(() => {
    if (!filtreParams.value.code_marque || filtreParams.value.code_marque.length === 0) {
        return [...new Set(store.state.rayons.map(Rayon =>`${Rayon.split('|')[1].trim()} - ${Rayon.split('|')[2].trim()}` ))]
    }

    const codesMarquesSelectionnes = filtreParams.value.code_marque.map(item => {
        if (typeof item === 'string') {
        return item.split('-')[0].trim()
        } else {
        return item.code ? item.code.split('-')[0].trim() : ''
        }
    }).filter(code => code !== '')

    return [...new Set(store.state.rayons
        .filter(Rayon => {
        const RayonsParts = Rayon.split('|')
        //   //console.log(RayonsParts);
        
        if (RayonsParts.length < 2) return false
        //   //console.log(codesMarquesSelectionnes);
        
        const codeMarqueRayons = RayonsParts[0].trim()
        return codesMarquesSelectionnes.includes(codeMarqueRayons)
        })
        .map(Rayon =>`${Rayon.split('|')[1].trim()} - ${Rayon.split('|')[2].trim()}` ))]
    })
    let itemsFamilles = computed(() => {
    if (!filtreParams.value.code_marque || filtreParams.value.code_marque.length === 0) {
        return [...new Set(store.state.familles.map(Famille =>`${Famille.split('|')[2].trim()} - ${Famille.split('|')[3].trim()}` ))]
    }

    const codesMarquesSelectionnes = filtreParams.value.code_marque.map(item => {
        if (typeof item === 'string') {
        return item.split('-')[0].trim()
        } else {
        return item.code ? item.code.split('-')[0].trim() : ''
        }
    }).filter(code => code !== '')

    return [...new Set(store.state.familles
        .filter(Famille => {
        const FamillesParts = Famille.split('|')
        //   //console.log(RayonsParts);
        
        if (FamillesParts.length < 2) return false
        //   //console.log(codesMarquesSelectionnes);
        
        const codeMarqueFamilles = FamillesParts[0].trim()
        return codesMarquesSelectionnes.includes(codeMarqueFamilles)
        })
        .map(Famille =>`${Famille.split('|')[2].trim()} - ${Famille.split('|')[3].trim()}` ))]
    })
    let itemsSousFamilles = computed(() => {
    if (!filtreParams.value.code_marque || filtreParams.value.code_marque.length === 0) {
        return [...new Set(store.state.sousFamilles.map(SousFamille =>`${SousFamille.split('|')[3].trim()} - ${SousFamille.split('|')[4].trim()}` ))]
    }

    const codesMarquesSelectionnes = filtreParams.value.code_marque.map(item => {
        if (typeof item === 'string') {
        return item.split('-')[0].trim()
        } else {
        return item.code ? item.code.split('-')[0].trim() : ''
        }
    }).filter(code => code !== '')

    return [...new Set(store.state.sousFamilles
        .filter(SousFamille => {
        const SousFamillesParts = SousFamille.split('|')
        //   //console.log(RayonsParts);
        
        if (SousFamillesParts.length < 2) return false
        //   //console.log(codesMarquesSelectionnes);
        
        const codeMarqueSousFamilles = SousFamillesParts[0].trim()
        return codesMarquesSelectionnes.includes(codeMarqueSousFamilles)
        })
        .map(SousFamille =>`${SousFamille.split('|')[3].trim()} - ${SousFamille.split('|')[4].trim()}` ))]
    })
    function setPromo(){
        filtreParams.value.promo=filtreParams.value.type_promo&&filtreParams.value.type_promo.length>0?true:null
    }
    // watch(checkedmarques,()=>{
    // console.log('checkedmarqueschange');

    //     itemsThemes=store.state.themes.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[1].trim())).map(x=>x.split('|')[0].trim())
    //     itemsRayons=store.state.rayons.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim()))
    //     itemsFamilles=store.state.familles.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim()))
    //     itemsSousFamilles=store.state.sousFamilles.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim()))
        
    // })
    // watch(checkedRayons,()=>{
    //     itemsFamilles=store.state.familles.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim())).filter(el=>checkedRayons.value.map(x=>x.split('|')[1].trim()).find(m=>m==el.split('|')[1].trim()))
    //     itemsSousFamilles=store.state.sousFamilles.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim())).filter(el=>checkedRayons.value.map(x=>x.split('|')[1].trim()).find(m=>m==el.split('|')[1].trim()))
        
    // })
    // watch(checkedFamilles,()=>{
    //     itemsSousFamilles=store.state.sousFamilles.filter(el=>checkedmarques.value.map(x=>x.split('-')[0].trim()).find(m=>m==el.split('|')[0].trim())).filter(el=>checkedRayons.value.map(x=>x.split('|')[1].trim()).find(m=>m==el.split('|')[1].trim())).filter(el=>checkedFamilles.value.map(x=>x.split('|')[2].trim()).find(m=>m==el.split('|')[2].trim()))

    // })

    let scanBarCode=computed(()=>{
        //console.log('recherche', store.state.scanBarCode);
        
        return store.state.scanBarCode
    })
    
    async function getArticles(){   
        
        store.commit('updateWaiting')
        store.commit('updateComponent',router.currentRoute.value.name)
        // let url=    `http://localhost:8282/apimyedisac/articlesdeep`
        let url=    `https://my.edisac.com/api/articlesdeep`
        let params={
            reference:filtreParams.value.reference?filtreParams.value.reference.trim().toUpperCase():null,
            marques:filtreParams.value.code_marque?filtreParams.value.code_marque.map(x=>x=x.split("-")[0].trim()):null,
            themes:filtreParams.value.code_theme?filtreParams.value.code_theme.map(x=>x=x.split("-")[0].trim()):null,
            rayons:filtreParams.value.code_rayon?filtreParams.value.code_rayon.map(x=>x=x.split("-")[0].trim()):null,
            familles:filtreParams.value.code_famille?filtreParams.value.code_famille.map(x=>x=x.split("-")[0].trim()):null,
            sousfamilles:filtreParams.value.code_sousfamille?filtreParams.code_value.code_sousfamille.map(x=>x=x.split("-")[0].trim()):null,
            collections:filtreParams.value.collection?filtreParams.value.collection:null,
            type_promo:filtreParams.value.type_promo?filtreParams.value.type_promo:null,
            promo:filtreParams.value.promo?filtreParams.value.promo:null,
            depot:store.state.etablissement,
            enStock:filtreParams.value.enStock?filtreParams.value.enStock:null,
            monStock:filtreParams.value.monStock?filtreParams.value.monStock:null
        }
        console.log(params);
        
        let config = {
        method : 'get',
        url : url,
        params : params
        };
        return   axios.request(config)
        .then((response) => {
            router.replace({ path: '/edisac' })
            store.commit('addArticles',response.data.articles) 
            store.commit('updateComponent',router.currentRoute.value.name)
            store.commit('updateWaiting')    
            refreshPrices(store.state.itemsEtablissemnt.etabDEPO.etabliss.includes(store.state.etablissement)?'WEDI':store.state.etablissement, new Date().toISOString().split('T')[0])  
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }
    async function refreshPrices(etablissement,date){
        // let max=Object.values(store.state.articles)
        // .flatMap(marque => Object.values(marque))  // Récupère tous les objets trad
        // .flatMap(theme => Object.keys(theme))      // Récupère toutes les clés des trad
        // .length;
        // let i=0            
        for(let marque in store.state.articles){
        for (let theme in store.state.articles[marque]){
            for (let ref in store.state.articles[marque][theme]){
                await refreshPrice(store.state.articles[marque][theme][ref],etablissement,date)
                // await refreshPeriodePromo(store.state.articles[marque][theme][ref],etablissement)
            }
        }
        }
    }
    // async function refreshPeriodePromo(references,etablissement){
    //     for (let bar in references){
    //         if(references[bar].type_promo&&references[bar].type_promo!=''){
    //             let config = {
    //             method: 'get',
    //             maxBodyLength: Infinity,
    //             url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement}/price-list-periods/v1/${references[bar].type_promo}`, //
    //             headers: { 
    //                 'Authorization': `Bearer ${store.state.token_y2}`, 
    //                 'Content-Type': 'application/json'
    //             }
    //             };
    //             // console.log(config.url);
    //             axios.request(config)
    //             .then((response) => {
    //             if(response.data.id){
    //                 periodProperties.value=`Uniquement ces couleurs sont en ${response.data.description} du ${response.data.dateRange.startDate.split('T')[0]} au ${response.data.dateRange.endDate.split('T')[0]}`
    //                 return
    //             }
                
    //             })
    //             .catch((error) => {
    //             //console.log(error);
    //             })
    //         }
        
    //     }
    //     periodProperties.value=null
    // }
    async function getBarCodes(reference){
        let barCodes=''
        for (let barcode in reference ){
        barCodes=barCodes+`&barcodes=${reference[barcode].codebarre}`
        }
        return barCodes
    }
    async function refreshPrice(reference,etablissement,date){
        let referenceCol= reference[Object.keys(reference)[0]]
        let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `/cegid-api/Y2/98661025_001_PROD/api/stores/${etablissement}/selling-prices/v1?taxExcluded=false&date=${date}${ await getBarCodes(reference)}`, //
        
        
        headers: { 
            'Authorization': `Bearer ${store.state.token_y2}`, 
            'Content-Type': 'application/json'
        }
        };
        // console.log(config.url);
        axios.request(config)
        .then((response) => {
        for( let price in response.data.prices){
            // if(response.data.prices[price].periodId!=store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo){
            if(response.data.prices[price].unitPrice.base!=response.data.prices[price].unitPrice.current){
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=response.data.prices[price].unitPrice.current.toFixed(1)
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=response.data.prices[price].periodId
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
            }else{
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].prix_promo=0
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].type_promo=''
                store.state.articles[referenceCol.code_marque][referenceCol.code_theme][referenceCol.reference_y2][response.data.prices[price].barcode].vte_euro=response.data.prices[price].unitPrice.base.toFixed(3)
            }
            // }
        }
        })
        .catch((error) => {
        //console.log(error);
        })  
    }
    watch(
        () => store.state.etablissement,
        (newValue, oldValue) => {
            refreshPrices(store.state.itemsEtablissemnt.etabDEPO.etabliss.includes(store.state.etablissement)?'WEDI':store.state.etablissement, new Date().toISOString().split('T')[0])
            // refreshPeriodePromo()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    // const getData=()=>{
        // itemsmarques=computed(()=>{
        //     return store.state.marques
        // })
        // itemsThemes=computed(()=>{
        //     return store.state.themes
        // })
        // itemsRayons=computed(()=>{
        //     return store.state.rayons
        // })
        // itemsFamilles=computed(()=>{
        //     return store.state.familles
        // })
        // itemsSousFamilles=computed(()=>{
        //     return store.state.sousFamilles
        // })
        // }
    function setDate(date){
        store.commit('setDate',date) 
    }
    onMounted(() => {
        setDate(new Date().toISOString().split('T')[0])
    })

</script>
<style>

</style>